import React from 'react';
import SelectableImage from './SelectableImage';
import './SelectableImageMultiple.scss';
import { ImageOption } from './CommonTypes';
import { SelectInputHelper } from './selectInput/SelectInput';

type SelectableImageMultipleProps = {
    imageOptions: ImageOption[];
    selectedItem: string;
    onChange: (selectedItem: string) => void;
};

const SelectableImageMultiple = React.memo(
    SelectableImageMultipleMono,
    (prevProps, currentProps) => {
        return prevProps.selectedItem === currentProps.selectedItem;
    }
);

function SelectableImageMultipleMono({
    imageOptions,
    selectedItem,
    onChange
}: SelectableImageMultipleProps): JSX.Element {
    const onImageClicked = (selected: boolean, name: string) => {
        onChange(selected ? name : SelectInputHelper.NullValue());
    };

    const renderSelectableImage = (imageOption: ImageOption) => {
        return (
            <SelectableImage
                key={imageOption.name}
                name={imageOption.name}
                selected={selectedItem === imageOption.name}
                image={imageOption.image}
                altText={imageOption.altText}
                label={imageOption.label}
                onClicked={(selected) =>
                    onImageClicked(selected, imageOption.name)
                }
            />
        );
    };

    return (
        <div className='images-wrapper'>
            {imageOptions.map((imageOption) =>
                renderSelectableImage(imageOption)
            )}
        </div>
    );
}

export default SelectableImageMultiple;
